// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from 'vuestic-ui/src/services/ColorThemePlugin'
import store from '../store/index'
import router from '../router/index'
import VuesticPlugin from 'vuestic-ui/src/components/vuestic-plugin'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import VeeValidate from 'vee-validate'
import '../metrics'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vDialog from 'v-dialogs'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
// import VuePlyr from 'vue-plyr'
import VueApexCharts from 'vue-apexcharts'
import VueSelectImage from 'vue-select-image'
import { VueEditor } from "vue2-editor";

import moment from 'moment'
Vue.use(moment)
Vue.component('VueEditor', VueEditor)
Vue.use(VueSelectImage)
import VueExcelXlsx from "vue-excel-xlsx";

Vue.use(VueExcelXlsx);

// add stylesheet
require('vue-select-image/dist/vue-select-image.css')

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// The second argument is optional and sets the default config values for every player.
// Vue.use(VuePlyr, {
//   plyr: {
//     fullscreen: { enabled: false },
//   },
//   emit: ['ended'],
// })
Vue.use(Viewer)
Vue.component('VueElementLoading', VueElementLoading)
window.axios = require('axios')
Vue.use(axios)
//Production
axios.defaults.baseURL = 'http://3.109.132.76'
Vue.prototype.baseURL="http://3.109.132.76/document/get/"
Vue.prototype.mediaURL="http://3.109.132.76/file/get/"

//Test
// axios.defaults.baseURL = "http://192.168.59.200:4003"
// Vue.prototype.baseURL="http://192.168.59.200:4003/document/get/"
// Vue.prototype.videoURL="http://192.168.59.200:4003/file/get/"
// Vue.prototype.ipURL = "http://192.168.59.200:4003"
Vue.use(Vuex)
Vue.use(BootstrapVue)
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

Vue.use(vDialog, { language: 'en' })

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)

Vue.use(ColorThemePlugin,
  {
    // Add or change theme colors here
    themes: {
      // primary: '#f06595',
      // blurple: '#7289DA',
    },
  })

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
